import React, { FC } from 'react';

import HelpModal from './HelpModal';
import HelpModeOverlay from './HelpModeOverlay';
import { useHelpMode } from '../../hooks/useHelpMode';

const HelpModeController: FC = () => {
  const { helpData, closeHelp } = useHelpMode();

  return (
    <>
      <HelpModeOverlay />
      <HelpModal helpData={helpData} onClose={closeHelp} />
    </>
  );
};

export default HelpModeController;
